import { Logger } from '@/utils/logger';
import { getTsCustomerPortalClient } from '@montugroup/circuit-shared/api/customer-portal.client';
import { useCallback, useState } from 'react';

const logger = new Logger('useGetOnboardKeyStatus');

export const client = getTsCustomerPortalClient();

// exporting am inferred type so it can be used in the function definition for the onSuccessCallback function
type MutationResult = ReturnType<typeof client.getOnboardKeyStatus.useMutation>;
type MutateAsync = MutationResult['mutateAsync'];
export type TOnboardKeyStatusData = Awaited<ReturnType<MutateAsync>>;

/**
 * useGetOnboardKeyStatus returns the status of the onboard link sent to the customer
 *
 * @returns a mutate function to check the status of the onboard key
 */
export function useGetOnboardKeyStatus() {
  const [onboardKeyStatus, setOnboardKeyStatus] = useState<TOnboardKeyStatusData['body']['data'] | undefined>();
  const { mutate, isPending } = client.getOnboardKeyStatus.useMutation();

  const getOnboardKeyStatusMutate = useCallback(
    (onboardKey: string, onSuccessCallback: (data: TOnboardKeyStatusData) => void, onErrorCallback?: () => void) =>
      mutate(
        { body: { onboardKey } },
        {
          onSuccess: (data) => {
            logger.info('onboardKey status successfully returned');
            setOnboardKeyStatus(data.body.data);
            onSuccessCallback(data);
          },
          onError: (err) => {
            logger.error(err);
            onErrorCallback && onErrorCallback();
          },
        },
      ),
    [mutate],
  );

  return {
    getOnboardKeyStatusMutate,
    onboardKeyStatus,
    isPending,
  };
}
